import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SwipeRevealListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,
      startX: 0,
      currentTranslateX: 0,
      deckWidth: 260,
    };
    this.deckRef = React.createRef();
    this.surfaceRef = React.createRef();
    this.hasMoved = false;
  }

  componentDidMount() {
    this.updateDeckWidth();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpenSwipe !== this.props.isOpenSwipe) {
      this.updateDeckWidth();
    }
  }

  updateDeckWidth = () => {
    if (this.deckRef.current) {
      const width = this.deckRef.current.offsetWidth;
      if (width > 0 && width !== this.state.deckWidth) {
        this.setState({ deckWidth: width });
      }
    }
  };

  getMaxTranslateX = () => {
    const { deckWidth } = this.state;
    return deckWidth > 8 ? deckWidth - 6 : deckWidth;
  };

  // Pointer Drag Handlers (Unified Touch + Mouse)
  handlePointerDown = (e) => {
    if (e.button !== 0 && e.pointerType === 'mouse') return;
    if (e.target.closest('input, button, .export-label-chip, .btn-more-options')) return;

    this.hasMoved = false;
    this.justDragged = false;
    this.startX = e.clientX;
    const maxOpen = this.getMaxTranslateX();
    this.initialTranslate = this.props.isOpenSwipe ? -maxOpen : 0;
    this.isPointerDown = true;

    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch (err) {}

    this.setState({
      currentTranslateX: this.initialTranslate,
    });
  };

  handlePointerMove = (e) => {
    if (!this.isPointerDown) return;
    const diff = e.clientX - this.startX;

    if (!this.hasMoved && Math.abs(diff) > 4) {
      this.hasMoved = true;
      if (!this.state.isDragging) {
        this.setState({ isDragging: true });
      }
    }

    if (!this.hasMoved) return;

    const maxOpen = this.getMaxTranslateX();
    let target = this.initialTranslate + diff;
    if (target > 0) target = 0;
    if (target < -maxOpen) {
      const excess = -maxOpen - target;
      target = -maxOpen - excess * 0.2;
    }

    this.setState({ currentTranslateX: target });
  };

  handlePointerUp = (e) => {
    if (!this.isPointerDown) return;
    this.isPointerDown = false;

    try {
      e.currentTarget.releasePointerCapture(e.pointerId);
    } catch (err) {}

    if (this.state.isDragging) {
      this.setState({ isDragging: false });
    }

    if (this.hasMoved) {
      this.justDragged = true;
      setTimeout(() => {
        this.justDragged = false;
      }, 100);
      const maxOpen = this.getMaxTranslateX();
      const threshold = -maxOpen * 0.3;
      const shouldOpen = this.state.currentTranslateX < threshold;
      this.props.onToggleSwipe(shouldOpen);
    }
  };

  handleSurfaceClick = (e) => {
    if (this.justDragged) {
      this.justDragged = false;
      return;
    }
    if (e.target.closest('input, button, .export-label-chip, .btn-more-options')) return;

    if (this.props.isOpenSwipe) {
      this.props.onToggleSwipe(false);
    } else if (this.props.onCloseAnyOpen) {
      this.props.onCloseAnyOpen();
    }
  };

  // 2-Finger Trackpad Horizontal Swipe Handler
  handleWheel = (e) => {
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 10) {
      if (e.deltaX > 15) {
        if (!this.props.isOpenSwipe) {
          this.props.onToggleSwipe(true);
        }
      } else if (e.deltaX < -15) {
        if (this.props.isOpenSwipe) {
          this.props.onToggleSwipe(false);
        }
      }
    }
  };

  handleToggleMoreOptions = (e) => {
    e.stopPropagation();
    this.props.onToggleSwipe(!this.props.isOpenSwipe);
  };

  handleLabelActionClick = (e) => {
    e.stopPropagation();
    this.props.onToggleSwipe(false);
    this.props.onOpenLabel(this.props.item.id);
  };

  render() {
    const {
      item,
      exportType,
      fullUrl,
      hasLabel,
      labelTitle,
      label,
      isOpenEdit,
      isOmniPlayer,
      canDeleteToggle,
    } = this.props;

    const { isDragging, currentTranslateX } = this.state;
    const isOpenSwipe = this.props.isOpenSwipe;
    const maxOpen = this.getMaxTranslateX();

    // Determine translateX
    let translateX = 0;
    if (isDragging) {
      translateX = currentTranslateX;
    } else {
      translateX = isOpenSwipe ? -maxOpen : 0;
    }

    return (
      <div
        className={`swipe-reveal-container ${isOpenSwipe ? 'is-open' : ''} ${isDragging ? 'is-swiping' : ''}`}
        id={`swipe-export-${item.id}`}
      >
        {/* REVEALED ACTION DECK (Bottom Layer) */}
        <div
          ref={this.deckRef}
          className="swipe-action-deck"
          aria-hidden={!isOpenSwipe}
        >
          {isOmniPlayer ? (
            <React.Fragment>
              <button
                type="button"
                className="swipe-action-btn share"
                title="Share Live Stream"
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.onToggleSwipe(false);
                  this.props.onShareVideo(item);
                }}
              >
                <i className="material-icons-outlined">share</i>
              </button>
              <button
                type="button"
                className="swipe-action-btn embed"
                title="Copy Embed Code"
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.onToggleSwipe(false);
                  this.props.onCopyEmbedCode(item);
                }}
              >
                <img src="/images/share_icon.svg" alt="embed" />
              </button>
              <button
                type="button"
                className="swipe-action-btn play"
                title="Play Video"
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.onToggleSwipe(false);
                  this.props.onPlayVideo(item);
                }}
              >
                <img src="/images/play_icon.svg" alt="play" />
              </button>
            </React.Fragment>
          ) : null}

          {/* Copy URL Action */}
          <button
            type="button"
            className="swipe-action-btn copy"
            title="Copy stream URL"
            onClick={(e) => {
              e.stopPropagation();
              this.props.onToggleSwipe(false);
              this.props.onCopyUrl(item);
            }}
          >
            <i className="material-icons">content_copy</i>
          </button>

          {/* Label Action */}
          <button
            type="button"
            className="swipe-action-btn swipe-btn-label"
            title={labelTitle}
            onClick={this.handleLabelActionClick}
          >
            <i className="material-icons">{label ? (isOpenEdit ? 'label' : 'label_off') : 'label'}</i>
          </button>

          {/* Edit Action (Non-OmniPlayer) */}
          {!isOmniPlayer && (
            <button
              type="button"
              className="swipe-action-btn edit"
              title="Edit export settings"
              onClick={(e) => {
                e.stopPropagation();
                this.props.onToggleSwipe(false);
                this.props.onEdit(item);
              }}
            >
              <i className="material-icons">
                {exportType.id === 'SRTListener' ? 'autorenew' : 'edit'}
              </i>
            </button>
          )}

          {/* Delete Action */}
          {canDeleteToggle && (
            <button
              type="button"
              className="swipe-action-btn delete"
              title="Delete export"
              onClick={(e) => {
                e.stopPropagation();
                this.props.onToggleSwipe(false);
                this.props.onDelete(item);
              }}
            >
              <i className="material-icons">delete_outline</i>
            </button>
          )}

          {/* Power / Enable Toggle Action */}
          {canDeleteToggle && (
            <button
              type="button"
              className={`swipe-action-btn power ${item.isEnabled ? 'active' : 'inactive'}`}
              title={item.isEnabled ? 'Disable export' : 'Enable export'}
              onClick={(e) => {
                e.stopPropagation();
                this.props.onToggleSwipe(false);
                this.props.onToggleEnable(item);
              }}
            >
              <i className="material-icons">power_settings_new</i>
            </button>
          )}
        </div>

        {/* FRONT SURFACE CARD (Top Layer) */}
        <div
          ref={this.surfaceRef}
          className={`swipe-surface-card ${isDragging ? 'is-dragging' : ''} ${isOpenSwipe ? 'is-open' : ''}`}
          style={{
            transform: `translateX(${translateX}px)`,
            transition: isDragging ? 'none' : 'transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
          onPointerDown={this.handlePointerDown}
          onPointerMove={this.handlePointerMove}
          onPointerUp={this.handlePointerUp}
          onPointerCancel={this.handlePointerUp}
          onWheel={this.handleWheel}
          onClick={this.handleSurfaceClick}
        >
          {/* Row 1: Icon + Title (Left) and Label + Active Badge + More Options (Right) */}
          <div className="swipe-surface-top">
            <div className="swipe-title-group">
              <div className="export-type-icon">
                {this.props.renderExportIcon(exportType.id, exportType.iconType)}
              </div>
              <div className="swipe-info-col">
                <span className="export-type-name">{exportType.name}</span>
                {exportType.subTitle && (
                  <span className="export-channel-subtitle">{exportType.subTitle}</span>
                )}
              </div>
            </div>

            <div className="swipe-top-right">
              {hasLabel && (
                <div className="created-export-inline-label">
                  {this.props.renderLabelItem(item.id)}
                </div>
              )}

              <span
                className={`badge-active-state ${item.isEnabled ? 'active' : 'inactive'}`}
                title={item.isEnabled ? 'Export is streaming/enabled' : 'Export is disabled'}
              >
                {item.isEnabled ? 'ACTIVE' : 'INACTIVE'}
              </span>

              <button
                type="button"
                className="btn-more-options"
                title="More actions (Swipe or Click)"
                onClick={this.handleToggleMoreOptions}
              >
                <i className="material-icons">more_horiz</i>
              </button>
            </div>
          </div>

          {/* Row 2: Full Stream URL */}
          <div className="swipe-surface-url">
            <span className="export-full-url-text" title={fullUrl}>
              {fullUrl}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

SwipeRevealListItem.propTypes = {
  item: PropTypes.object.isRequired,
  exportType: PropTypes.object.isRequired,
  fullUrl: PropTypes.string.isRequired,
  hasLabel: PropTypes.bool.isRequired,
  labelTitle: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  isOpenEdit: PropTypes.bool.isRequired,
  isOpenNew: PropTypes.bool.isRequired,
  isOmniPlayer: PropTypes.bool.isRequired,
  canDeleteToggle: PropTypes.bool.isRequired,
  isOpenSwipe: PropTypes.bool.isRequired,
  onToggleSwipe: PropTypes.func.isRequired,
  onCloseAnyOpen: PropTypes.func,
  renderLabelItem: PropTypes.func.isRequired,
  renderExportIcon: PropTypes.func.isRequired,
  onCopyUrl: PropTypes.func.isRequired,
  onToggleEnable: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onOpenLabel: PropTypes.func.isRequired,
  onShareVideo: PropTypes.func,
  onCopyEmbedCode: PropTypes.func,
  onPlayVideo: PropTypes.func,
};

export default SwipeRevealListItem;
